<template>
  <!--获赞页面-->
  <tk-container
    hide-status-bar
    disable-scroll
  >
    <!--列表头部-->
    <grey-header slot="header" :title="'获赞'"></grey-header>
    <!--列表详情-->
    <tk-container
      class="b-g-f"
      infiniteScroll
      @loadingMore="getPraisePosts"
    >
      <template v-if="praisePosts.length">
        <div style="height: 1px"></div>
        <div
          class="m-x-12 m-t-24"
          v-for="(s, index) in praisePosts"
          :key="index"
        >
          <template v-if="s.InformationPosts">
            <tk-flex middle class="full-height">
              <tk-avatar size="30" class="m-t-2">
                <tk-image :src="s.userFans.avatar ? s.userFans.avatar : defaultImage" width="30" height="30"></tk-image>
              </tk-avatar>
              <tk-flex middle column class="m-l-10">
                <tk-flex class="font-14">
                  <div>{{s.userFans.name}}</div>
                  <div style="color: #999;" class="m-l-10">赞了你的帖子</div>
                </tk-flex>
                <div class="caption m-t-5 m-l-2">{{s.createdAt | datetime}}</div>
              </tk-flex>
            </tk-flex>
            <tk-flex class="praise-posts m-t-10"
                     @click.native="$push({path: '/community/postsDetail', query: {  id: s.InformationPosts.objectId }})">
              <div class="posts-image" v-if="s.InformationPosts.pictureCombination &&
             s.InformationPosts.pictureCombination.length">
                <tk-image class="img-radius" :src="s.InformationPosts.pictureCombination[0]" width="75" height="75"></tk-image>
              </div>
              <div class="p-12" v-if="s.InformationPosts.content">
                <div v-html="getArticleText(s.InformationPosts.content)" class="posts-content van-multi-ellipsis--l2"></div>
              </div>
            </tk-flex>
          </template>
        </div>
      </template>
    </tk-container>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      praisePosts: [] // 点赞列表
    }
  },
  computed: {
    // 个人主页用户Id
    profileId () {
      return this.$route.query.id
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    async getPraisePosts (page, next) {
      let praisePosts = await this.$tkParse.getList(`/classes/praisePosts`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-createdAt',
          include: ['InformationPosts', 'userFans'],
          where: {
            praiseUser: this.profileId,
            InformationPosts: {
              $exists: true
            }
          }
        }
      })
      this.praisePosts = [...this.praisePosts, ...praisePosts]
      if (praisePosts.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 获取html中的文字
     * @date: 2020/3/23
     */
    getArticleText (html) {
      // return html.replace(/<\/?(img)[^>]*>/gi, '')
      let value = html.replace(/<\/?(img)[^>]*>/gi, '')
      if (value.length > 60) {
        return value.slice(0, 60) + '...'
      }
      return value
    }
  }
}
</script>

<style scoped lang="scss">
/*帖子样式*/
  .praise-posts {
    background: rgba(245, 245, 245, 1);
    min-height: 75px;
    .posts-image {
      width: 75px;
      height: 75px;
    }
    .posts-content {
      /*overflow:hidden;*/
    }
  }
</style>
